// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__2KVTS","balanceDisclaimer":"posDashboard_balanceDisclaimer__3e5vj"};